module.exports = __webpack_public_path__ + "img/jp-about-us-bg.1313f00.png";